import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

// Microphone icon component
const MicrophoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.49 6-3.31 6-6.72h-1.7z"/>
  </svg>
);

/**
 * Minimized View - Polished Header Button
 * 
 * Features:
 * - Pill-shaped button with microphone icon + text
 * - 40px height to match header elements
 * - Visual states and subtle animations
 * - Professional styling that fits header design
 */
const MinimizedView = ({ onClick, isExpanded }) => {
  return (
    <S.HeaderButton 
      onClick={onClick}
      isExpanded={isExpanded}
      aria-label="Ask Dasha - Start voice conversation"
    >
      <MicrophoneIcon />
      <S.ButtonText>Ask Dasha</S.ButtonText>
    </S.HeaderButton>
  );
};

MinimizedView.propTypes = {
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool
};

MinimizedView.defaultProps = {
  isExpanded: false
};

export default MinimizedView;